<template>
  <el-dialog title="Prorrogar Vencimento do Aluguel" @open="reset" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="400px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item label="Data da Prorrogação">
            <el-date-picker
              v-model="form.dataPagamento"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button @click="calcularAluguelHandler" type="primary" size="small" style="margin-top:17px;" round class="btn-box-shadow">Calcular</el-button>
        </el-col>        
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-tag type="danger" style="font-size: 12px" v-if="this.recibo">
          Data de Vencimento Atual: {{ this.recibo.dataVencimento }}
          </el-tag>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Multa">
            <div class="el-input el-input--small">
              <money auto-complete="off" disabled v-model="form.multa" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Permanência Diária">
            <div class="el-input el-input--small">
              <money auto-complete="off" disabled v-model="form.permanenciaDiaria" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Juros">
            <div class="el-input el-input--small">
              <money auto-complete="off" disabled v-model="form.juros" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Horários Advocatícios">
            <div class="el-input el-input--small">
              <money auto-complete="off" disabled v-model="form.honorariosAdvocaticios" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Desconto">
            <div class="el-input el-input--small">
              <money v-model="form.desconto" v-bind="money" :disabled="desabilitarDesconto" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-tag type="tag 1" style="margin:20px 0; display:block; font-size: 15px">
            Total de Encargos: {{ this.formatarValor(this.totalEncargos) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-form-item label="Total">
            <div class="el-input el-input--small">
              <money auto-complete="off" disabled :value="totalCalculado" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>      
    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="prorrogarBoletoHandler" round class="btn-box-shadow">Prorrogar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import Util from '../../../util/funcoes.js';
import { Money } from "v-money";

export default {
  props: {
    recibo: Object,
    visibility: Boolean
  },
  components: {
    Money
  },
  data() {
    return {
      form: {
        dataPagamento: '',
        multa: 0,
        permanenciaDiaria: 0,
        juros: 0,
        honorariosAdvocaticios: 0,
        desconto: 0,
        total: 0,
      },
      calculado: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
    totalEncargos() {
      return this.form.multa + this.form.permanenciaDiaria + this.form.juros + this.form.honorariosAdvocaticios;
    },
    totalCalculado() {
      return (this.form.total - this.form.desconto);
    },
    desabilitarDesconto(){
      return !this.permissoes.concederDescontoProrrogarBoleto
    },
    
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'calcularAluguelCliente',
        'prorrogarBoleto'
    ]),
    
    calcularAluguelHandler() {
        let payload = { id: this.recibo.id, dataPagamento: this.form.dataPagamento }

        this.showLoading();
        this.calcularAluguelCliente(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.preencherCampos(resultado.item)
                    this.calculado = true;
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
    },
    preencherCampos(recibo) {
        recibo.itensRecibo.forEach((element) => {
            switch(element.categoria) {
            case "MULTA": 
                this.form.multa = element.valor
                break;
            case "PERMANENCIA_DIARIA":
                this.form.permanenciaDiaria = element.valor
                break;
            case "HONORARIOS_ADVOCATICIOS":
                this.form.honorariosAdvocaticios = element.valor
                break;
            case "JUROS":
                this.form.juros = element.valor
                break;
            }
        })

        this.form.total = recibo.valorPagamento;
    },
    prorrogarBoletoHandler() {
      if(!this.calculado){
        this.$message.warning("Você deve calcular o valor do boleto");
        return
      }

      if(this.usuarioLogado.imobiliaria.parametros.prorrogarComNovoBoleto) {
        this.$confirm('Um novo boleto será gerado e você precisará fazer a remessa desse boleto. Deseja continuar?', 'Atenção', {
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            type: 'warning'
        }).then(() => {
            this.prorrogarBoletoCliente();
        });
      } else {
        this.prorrogarBoletoCliente();
      }
    },
    prorrogarBoletoCliente() {
      let payload = { id: this.recibo.id, dataProrrogacao: this.form.dataPagamento, descontoProrrogacao: this.form.desconto }

        this.showLoading();
        this.prorrogarBoleto(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.concluirProrrogacao(resultado)
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });

        this.fechar();
    },
    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    reset() {
      this.form = {
        dataPagamento: '',
        multa: 0,
        permanenciaDiaria: 0,
        juros: 0,
        honorariosAdvocaticios: 0,
        desconto: 0,
        total: 0,
      }
      this.calculado = false
    },
    concluirProrrogacao(resultado) {
      this.$emit('concluirProrrogacao',resultado);
    },
    fechar() {
      this.$emit('close');
    } 
  }
}
</script>
